import styled from "styled-components";

export const Action = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    box-sizing: border-box;
    padding: 0 15px;

    div.Action__quality {
        width: 210px;
        height: 35px;
        display: flex;
        align-items: center;

        button.Action__quality__trigger {
            width: 100%;
            height: 100%;
        }
    }
`;
